import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable()
export class HttpConfig {
    public BASE_ENDPOINT: string =  environment.apiUrl + '/';
}
